import './MakeupAiLoader.css';

/**
 * Controlled makeup loader — parent owns progress (0–100) and rotating message.
 */
export default function MakeupAiLoader({
  active = true,
  progress = 0,
  message = '',
  title = '',
  className = '',
  iconSrc = '/loader/makeuploader.png',
}) {
  if (!active) return null;

  const pct = Math.max(0, Math.min(100, Math.round(Number(progress) || 0)));
  const line = String(message || '').trim() || 'One moment…';

  return (
    <div
      className={`makeup-ai-loader ${className}`.trim()}
      role="status"
      aria-live="polite"
      aria-label={`${line} ${pct} percent`}
    >
      <div className="makeup-ai-loader__aura" aria-hidden="true" />
      <div className="makeup-ai-loader__rail" aria-hidden="true">
        <img
          className="makeup-ai-loader__icon makeup-ai-loader__icon--ghost"
          src={iconSrc}
          alt=""
          draggable={false}
        />
        <img
          className="makeup-ai-loader__icon makeup-ai-loader__icon--fill"
          src={iconSrc}
          alt=""
          draggable={false}
        />
      </div>
      {title ? <p className="makeup-ai-loader__title">{title}</p> : null}
      <p className="makeup-ai-loader__message">{line}</p>
      <div className="makeup-ai-loader__progress" aria-hidden="true">
        <div className="makeup-ai-loader__progress-fill" style={{ width: `${pct}%` }} />
      </div>
      <p className="makeup-ai-loader__percent">{pct}%</p>
    </div>
  );
}
